import { useTranslation } from 'react-i18next';
import './SubscriberBadge.less';

const SubscriberBadge: React.FC = () => {
  const { t } = useTranslation();
  return <div className="subscriber-badge">{t('subscriber')}</div>;
};

export default SubscriberBadge;
